import { render, staticRenderFns } from "./CandidateWatermark.vue?vue&type=template&id=a7d4c712&scoped=true&"
import script from "./CandidateWatermark.vue?vue&type=script&lang=js&"
export * from "./CandidateWatermark.vue?vue&type=script&lang=js&"
import style0 from "./CandidateWatermark.vue?vue&type=style&index=0&id=a7d4c712&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d4c712",
  null
  
)

export default component.exports